<template>
  <el-scrollbar>
    <div style="margin: 15px">
      <h4>加班转调休信息：</h4>
      <div class="box">
      <el-form :model="employeeData" label-width="180px">
        <el-row>
          <el-col :span="11">
            <el-form-item label="员工：" required>
              <el-select v-model="employeeData.employee_no" placeholder="员工" filterable clearable :disabled="isEdit">
                <el-option v-for="item in employeeList" :key="item.value" :label="item.label" :value="item.value"/>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="加班日期：" required>
              <el-date-picker v-model="employeeData.work_date" type="date"
                              value-format="YYYY-MM-DD" style="width: 100%" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="11">
            <el-form-item label="开始时间：" required>
              <el-time-select
                  v-model="employeeData.start_time"
                  start="00:00"
                  step="00:30"
                  end="24:00"
                  placeholder="开始时间"
              />
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="结束时间：" required>
              <el-time-select
                  v-model="employeeData.end_time"
                  start="00:00"
                  step="00:30"
                  end="24:00"
                  placeholder="结束时间"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="11">
            <el-form-item label="加班转调休时长(小时)：" required>
              <el-input-number v-model="employeeData.overtime_hours" style="width: 100%"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="22">
            <el-form-item label="备注：">
              <el-input type="textarea" v-model="employeeData.remark" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      </div>
      <h4>附件：</h4>
      <div class="box">
      <el-form :model="employeeData" label-width="180px">
        <el-row>
          <el-col :span="11" >
            <el-form-item label="附件：">
              <kf-file-upload v-model="employeeData.file_id" :init-file="fileList"
                              @fileChange="fileChange"
                              :limit="10" :showTotalCnt="true" ></kf-file-upload>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="11" >
            <el-form-item label="附件照片：">
              <el-button type="primary" style="width: 100px;" plain @click="openCameraMain">附件拍照</el-button>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="11" >
            <el-form-item label="">
              <FrameItem v-model="employeeData.attach_photo_id" :file-list="attach_photo_id_obj" :item="uploadImgObj" ></FrameItem>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      </div>
      <el-row>
        <el-col :span="24" style="text-align: center">
          <el-button type="primary" :loading="loading" @click="save" >保存</el-button>
        </el-col>
      </el-row>
    </div>
  </el-scrollbar>
  <el-dialog v-model="dialogVisible" style="width: 800px;height: 550px;">
    <img id="view1" src="http://127.0.0.1:38088/video=stream&camidx=0" alt="主摄像头" style="width: 770px;height:450px;">
    <template #footer>
      <div class="dialog-footer">
        <el-button @click="closeCameraMain">取消</el-button>
        <el-button type="primary" @click="takePhotoTwo">
          拍照
        </el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script>
import {Plus} from "@element-plus/icons-vue";
import axios from 'axios'

export default {
  name: "EmployeeAdjustWork",
  components: {Plus},
  inject: ['$fn'],
  props: {
    componentParam: {
      type: String,
      required: true
    },
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  computed: {
    typeList() {
      return this.$store.getters['core/getDictList']('shift_type');
    }
  },
  data() {
    return {
      optionProps: {
        emitPath: true,
        label: "name",
        value: "id",
        checkStrictly: true
      },
      uploadImgObj: {
        component: 'image_upload',
        limit: 1,
      },
      employee_no: '',
      employeeData: {
        employee_no: '',
        employee_name: '',
        department_ids: [],
        position_ids: '',
        position_level: '',
        phone: '',
        email: '',
        photo: '',
        entry_date: '',
        is_probation: false,
        probation_end_date: '',
        labor_company_id:'',
        employee_type:''
      },
      isEdit:false,
      isShow:false,
      photoType:'',
      dialogVisible: false,
      departmentList: [],
      reasonList: [],
      employeeList:[],
      loading: false,
      fileList:[],
      attach_photo_id_obj:[]
    }
  },
  methods: {
    async loadEmployeeAdjustRecord() {
      let params = {id: this.parentData.id}
      this.$http('attendanceAdjustWorkService.getAdjustWorksById', params).then(data => {
        if (data) {
          this.isEdit = true;
          this.attach_photo_id_obj = data.attach_photo_id_obj;
          this.fileList = data.file_list;
          this.employeeData = data;
        }
      }, errMsg => {
        //this.$message.error(errMsg)
        console.log(errMsg);//具体的message信息，等同⽤$axios时的error.message
      });
    },
    //获取员工
    async getEmployee(){
      this.employeeList =await this.$http('attendanceLeaveService.getEmployeeList');
    },
    async openCameraMain(){
      this.dialogVisible = true;
      const image = document.getElementById('view1');
      image.src = 'http://127.0.0.1:38088/video=stream&camidx=0?1';
    },
    closeCameraMain(){
      let data = {"camidx": "0"}
      axios.post("http://127.0.0.1:38088/video=close", JSON.stringify(data)).then(()=>{
        document.getElementById('view1').src = ''
      });
      this.dialogVisible = false;
    },
    takePhotoTwo(){
      let params = {
        "filepath": "base64",
        "camidx": "0",
        "ColorMode": "0",
        "quality": "1"
      }
      axios.post("http://127.0.0.1:38088/video=grabimage", JSON.stringify(params)).then(response=>{
        if(response){
          let photoData = {photo: response.data};
          this.$http('photoService.takePhotoByMainCamera',photoData, false).then(data => {
            if(data){
              this.employeeData.attach_photo_id = data.avatar;
              this.attach_photo_id_obj = [data.file];
              this.dialogVisible = false;
            }
          }, errMsg => {
            this.$message.error(errMsg)
            console.log(errMsg);//具体的message信息，等同⽤$axios时的error.message
          });
        }
      });
    },
    save() {
      if (!this.employeeData) {
        this.$message.error("请选择员工");
        return;
      }
      if (!this.employeeData.employee_no) {
        this.$message.error("请选择员工");
        return;
      }
      if (!this.employeeData.work_date) {
        this.$message.error("请选择加班时间");
        return;
      }
      if (!this.employeeData.start_time) {
        this.$message.error("请选择开始时间");
        return;
      }
      if (!this.employeeData.end_time) {
        this.$message.error("请选择结束时间");
        return;
      }
      if (!this.employeeData.overtime_hours) {
        this.$message.error("请填写加班时长");
        return;
      }
      this.loading = true;
      this.$http('attendanceAdjustWorkService.saveAdjustWork', this.employeeData, false).then(() => {
        this.$message.success("保存成功");
        this.$fn.closeWindow();
        this.$fn.search();
        this.loading = false;
      }, errMsg => {
        this.$message.error(errMsg)
        // console.log(errMsg);//具体的message信息，等同⽤$axios时的error.message
        this.loading = false;
      })
    },
    async fileChange(ids) {
      if (ids.length <= 0) {
        return
      }
      this.employeeData.file_id = ids;
    },
  },
  created() {
    this.getEmployee();
    this.loadEmployeeAdjustRecord();
  },
}
</script>

<style scoped lang="less">
.box {
  padding-top: 10px;
  border: 1px solid #cccccc;
  border-radius: 5px;
  margin: 10px 0;
}

</style>